import { render, staticRenderFns } from "./CadAnuncios.vue?vue&type=template&id=25dfb945&scoped=true&"
import script from "./CadAnuncios.ts?vue&type=script&lang=ts&"
export * from "./CadAnuncios.ts?vue&type=script&lang=ts&"
import style0 from "./anuncios.scss?vue&type=style&index=0&id=25dfb945&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dfb945",
  null
  
)

export default component.exports